import type { Document } from "@/types/document";
import { DocumentTable } from "./DocumentTable";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

interface DocumentListProps {
  documents: Document[];
  onPreview: (document: Document) => void;
  onDownload: (document: Document) => void;
  onDelete: (id: string) => void;
  onRefresh: () => void;
}

export function DocumentList({ documents, onPreview, onDownload, onDelete, onRefresh }: DocumentListProps) {
  if (documents.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No documents found. Create a document from a template to get started.
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-end mb-4">
        <Button
          variant="outline"
          size="sm"
          onClick={onRefresh}
          className="flex items-center gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Refresh
        </Button>
      </div>
      <DocumentTable
        documents={documents}
        onPreview={onPreview}
        onDownload={onDownload}
        onDelete={onDelete}
      />
    </div>
  );
}